import React from "react";
import { styled } from "@mui/material/styles";
import { Link as RouterLink } from "react-router-dom";
import PropTypes from "prop-types";
import LanguageSelector from "../LanguageSelector";
import { useTranslation } from "react-i18next";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Badge from "@mui/material/Badge";
import Grid from "@mui/material/Grid";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import Tooltip from "@mui/material/Tooltip";
import { styledSlots, resolveStyledSlots } from "../../_helpers/styledSlots";
import LifeSaferLogo from "@/_images/LSISA_Logo.png";

const StyledIconButton = styled(IconButton)(({ theme }) =>
  styledSlots(
    resolveStyledSlots(
      (theme) => ({
        root: {
          [theme.breakpoints.down("sm")]: {
            padding: "12px 6px",
          },
        },
      }),
      theme,
    ),
  ),
);
const componentStyles = (theme) => ({
  menuButton: {
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
    [theme.breakpoints.up("sm")]: {
      marginRight: theme.spacing(2),
    },
    [theme.breakpoints.down("sm")]: {
      marginRight: 0,
    },
  },
  badgeColor: {
    backgroundColor: "#d1495b",
  },
  logo: {
    [theme.breakpoints.up("sm")]: {
      width: 168,
      height: 34,
    },
    [theme.breakpoints.down("lg")]: {
      width: 109,
      height: "auto",
    },
  },
});
const StyledRoot = styled("div")(({ theme }) => ({
  display: "contents",
  ...Object.entries(componentStyles(theme)).reduce(
    (acc, [className, style]) => ({
      ...acc,
      [`& .${className}, &.${className}`]: style,
    }),
    {},
  ),
}));
export const NavToolbar = ({
  selectedNav,
  invisible,
  handleDrawerToggle,
  setMobileOpen,
  updateSelectedNav,
}) => {
  const { t } = useTranslation();
  NavToolbar.propTypes = {
    selectedNav: PropTypes.string.isRequired,
    invisible: PropTypes.bool.isRequired,
    handleDrawerToggle: PropTypes.func.isRequired,
    setMobileOpen: PropTypes.func.isRequired,
    updateSelectedNav: PropTypes.func.isRequired,
  };
  return (
    <StyledRoot>
      <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
        <Grid sx={{ display: "flex", alignItems: "center" }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            className={"menuButton"}
            size="large"
          >
            <MenuIcon
              style={{
                color: "#76bc21",
              }}
            />
          </IconButton>
          <RouterLink to="/dashboard">
            <img
              className={"logo"}
              src={LifeSaferLogo}
              alt="LifeSaferISA"
              onClick={() => {
                updateSelectedNav("/dashboard");
              }}
            />
          </RouterLink>
        </Grid>
        <Grid
          container
          sx={{
            flexDirection: "row",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <Grid>
            <LanguageSelector />
          </Grid>
          <Grid>
            <Tooltip title={t("navigation.profile")}>
              <StyledIconButton
                edge="end"
                aria-label="account of current user"
                aria-haspopup="true"
                color="inherit"
                component={RouterLink}
                to={"profile"}
                onClick={() => {
                  setMobileOpen(false);
                  updateSelectedNav("/profile");
                }}
              >
                <Badge
                  invisible={invisible}
                  badgeContent={"!"}
                  classes={{
                    badge: "badgeColor",
                  }}
                >
                  {selectedNav === "/profile" ? (
                    <AccountCircle
                      style={{
                        color: "#76bc21",
                      }}
                      fontSize="large"
                    />
                  ) : (
                    <AccountCircle
                      style={{
                        color: "#1c355e",
                      }}
                      fontSize="large"
                    />
                  )}
                </Badge>
              </StyledIconButton>
            </Tooltip>
          </Grid>
        </Grid>
      </Toolbar>
    </StyledRoot>
  );
};
